// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "llc.besc",
    name: "BeanBag",
    homepage: "https://besc.llc",
    image_id: "5fad49d2-a138-47bb-ac87-6368d8bd9000",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.beanbag.wallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "beanbag://wallet/connect",
        universal: "https://play.google.com/store/apps/details?id=com.beanbag.wallet",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map